<template>
  <header id="wsc-header" class="wsc-header">
    <div class="wsc-header-top">
      <div class="container">
        <div
          class="wsc-header-top-content wsc-header-content d-lg-flex justify-content-between"
        >
          <div
            class="wsc-header-top-logo wsc-header-logo d-flex justify-content-between align-items-center"
          >
            <a
              href="https://www.wondershare.com/"
              class="d-inline-block d-lg-flex align-items-center text-center"
            >
              <img
                src="https://images.wondershare.com/wsc-18/assets/icon/logo/wondershare-vertical-white.svg"
                class="d-none d-lg-inline-block img-fluid"
              />
              <img
                src="https://images.wondershare.com/wsc-18/assets/icon/logo/wondershare-square.svg"
                class="d-lg-none img-fluid"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wsc-header-bottom bg-primary text-white link-inherit">
      <div class="container">
        <div
          class="wsc-header-bottom-content wsc-header-content d-lg-flex justify-content-between align-items-center"
        >
          <div
            class="wsc-header-bottom-logo wsc-header-logo d-flex justify-content-center align-items-center"
          >
            <a
              class="d-inline-block"
              click-menu=".wsc-header-bottom-list-wrapper"
              href="/"
            >
              <i class="logo-pro"></i>
            </a>
          </div>
          <div
            class="wsc-header-bottom-list-wrapper wsc-header-menu-wrapper d-lg-inline-flex"
          >
            <ul class="wsc-header-bottom-list wsc-header-menu d-lg-flex">
              <li>
                <nav>
                  <a href="javascript:void(0)" v-show="email" @click="signOut"
                    >{{ email }}, Log out</a
                  >
                  <a
                    v-show="!email"
                    id="a_signin"
                    href="#login-box"
                    data-login=".sign-in"
                    >Signin</a
                  >
                </nav>
              </li>
              <li>
                <nav><router-link to="/faqs">FAQs</router-link></nav>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <nav class="wsc-header-close d-lg-none">
      <i class="wsc-icon" data-icon="close"></i>
    </nav>
  </header>
</template>

<script>
import MyLocalStorage from "../../../utils/MyLocalStorage";
import swal from "sweetalert";

export default {
  name: "MyHeader",
  computed: {
    email() {
      return this.$store.getters.nickname;
    }
  },
  mounted() {
    if ($(window).width() <= 992) {
      let click_menu = $("[click-menu]");
      click_menu.attr("href", "javascript:void(0);");
      click_menu.on("click", function() {
        var $this = $(this);
        var click_menu = $this.attr("click-menu");
        $this.toggleClass("active");
        $(click_menu).toggleClass("active");
        $("body").toggleClass("overflow-hidden");
        $(click_menu).on("click", function() {
          $this.removeClass("active");
          $(this).removeClass("active");
          $("body").removeClass("overflow-hidden");
        });
        $(click_menu)
          .children()
          .on("click", function(e) {
            e.stopPropagation();
          });
      });
    }
    $("[data-login]").on("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      let thislogin = $(this).attr("data-login");
      let poplogin = $(this).attr("href");
      if (thislogin === "close") {
        $(this)
          .parents(poplogin)
          .removeClass("show");
      } else {
        $(poplogin)
          .find(".sign-box")
          .hide();
        $(poplogin)
          .addClass("show")
          .find(thislogin)
          .show();
      }
    });
  },
  methods: {
    signOut() {
      let title = "Are you sure to log out.";
      if (this.$store.state.step > 2 && this.$store.state.step < 6) {
        title = "Transfer will be cancelled, are you sure to log out.";
      }
      swal(title, {
        buttons: ["Cancel", "Confirm"]
      }).then(result => {
        if (!result) {
          return;
        }
        this.$store.commit("reset_user");
        this.$store.commit("set_step", 1);
        MyLocalStorage.removeAccessToken();
      });
    }
  }
};
</script>

<style scoped></style>
